import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, lazy } from "react";
import { Box } from "@mui/material";
// Real federated remote (contacts-ui) -- backs the link in contacts-api's real invite email
// (services/notify.py's accept_url: `${UI_BASE_URL}/contacts/invitations/accept?token=...`).
// UI_BASE_URL is the bare platform origin (www), not any one product site, since contacts are
// global across every site on the platform. Mounted top-level here (not under /app) so it works
// for a not-yet-signed-in invitee the same way the standalone page in contacts-ui itself does --
// contacts-ui owns the sign-in/claim/accept-invite flow entirely; this file only mounts it.
const RemoteAcceptInvitationPage = lazy(() => import("@coremind/contacts-ui").then((mod) => ({ default: mod.AcceptInvitationPage })));
export default function AcceptInvitationPage() {
    return (_jsx(Suspense, { fallback: _jsx(Box, { sx: { p: 4, textAlign: "center", fontSize: 12.5, color: "text.secondary" }, children: "Loading\u2026" }), children: _jsx(RemoteAcceptInvitationPage, {}) }));
}
